import React from 'react'
import {Link, graphql, useStaticQuery} from 'gatsby'
//import './header.module.scss'
import DarkModeToggle from '../components/darkModeSettings/DarkModeToggle';
import * as headerStyles from './componentStyles/header.module.scss'
import useDarkMode from 'use-dark-mode';
const Header = () => {
    const darkMode = useDarkMode();
    //console.log(darkMode.value);
    const data = useStaticQuery(graphql`
        query{
            site{
                siteMetadata{
                    title
                    author
                }
            }
            }
    `)
    return (
        <header className={headerStyles.header}>
            <h1 className={headerStyles.headerTitle}>
                <Link className={headerStyles.title} to="/">
                    <span><span>{data.site.siteMetadata.title}</span></span>
                    <span className={headerStyles.nameSpan}>{"by < "+data.site.siteMetadata.author+" />"}</span>
                </Link>
                <div style={{height:50}}>
                    <DarkModeToggle />
                </div>
            </h1>
            <nav>
                <ul className={headerStyles.navList}>
                    <li>
                        <Link activeStyle={darkMode.value ? {color: '#4ecca3', textDecoration: 'underline'} : {color: '#9932cc', textDecoration: 'underline'}} className={headerStyles.navItem} to="/">Home</Link>
                    </li>
                    <li>
                        <Link className={headerStyles.navItem} activeStyle={darkMode.value ? {color: '#4ecca3', textDecoration: 'underline'} : {color: '#9932cc', textDecoration: 'underline'}} to="/blog">Blog</Link>
                    </li>
                    <li>
                        <Link className={headerStyles.navItem} activeStyle={darkMode.value ? {color: '#4ecca3', textDecoration: 'underline'} : {color: '#9932cc', textDecoration: 'underline'}} to="/projects">Projects</Link>
                    </li>
                    <li>
                        <Link className={headerStyles.navItem} activeStyle={darkMode.value ? {color: '#4ecca3', textDecoration: 'underline'} : {color: '#9932cc', textDecoration: 'underline'}} to="/about">About</Link>
                    </li>
                    <li>
                        <Link className={headerStyles.navItem} activeStyle={darkMode.value ? {color: '#4ecca3', textDecoration: 'underline'} : {color: '#9932cc', textDecoration: 'underline'}} to="/contact">Contact</Link>
                    </li>
                </ul>
            </nav>
        </header>
    )
}

export default Header
